const DEFAULT_CUSTOM_PACING_API_ROUTE = '/api/custom-pacing';

export const UPLOAD_CSV_ENDPOINT = `${DEFAULT_CUSTOM_PACING_API_ROUTE}/upload-csv`;
export { DEFAULT_CUSTOM_PACING_API_ROUTE };
